import React from 'react'
import { useHistory } from 'react-router-dom'
import shortid from 'shortid'
import { SurveyListItem } from '../api/models/SurveyListItem'
import { createNewSurvey, fetchSurveyListItems } from '../api/surveyApi'
import { Button, ButtonState } from '../components/Button'
import { DataTable } from '../components/DataTable'
import { SettingsPanel } from '../components/SettingsPanel'

export function SurveyList() {
  const history = useHistory()
  const [
    loadingSurveyStatus,
    setLoadingSurveyStatus,
  ] = React.useState<ButtonState>('idle')
  const [creatingStatus, setCreateStatus] = React.useState<ButtonState>('idle')
  const [surveyListItems, setSurveyListItems] = React.useState<
    SurveyListItem[]
  >([])

  React.useEffect(() => {
    setLoadingSurveyStatus('pending')
    fetchSurveyListItems().then(
      items => {
        setSurveyListItems(items)
        setLoadingSurveyStatus('resolved')
      },
      () => {
        setLoadingSurveyStatus('rejected')
      }
    )
  }, [])

  function handleCreateSurvey(): Promise<void> {
    const id = shortid()
    setCreateStatus('pending')
    return createNewSurvey(id).then(
      () => {
        setCreateStatus('resolved')
        history.push(`/surveys/${id}`)
      },
      e => {
        setCreateStatus('rejected')
      }
    )
  }

  return (
    <>
      <SettingsPanel className="mb-8" />
      <DataTable
        loading={
          loadingSurveyStatus === 'pending' || creatingStatus === 'pending'
        }
        handleCreateSurvey={handleCreateSurvey}
        surveys={surveyListItems}
      />

      <div className="mx-4 mt-4">
        <Button
          loading={creatingStatus === 'pending'}
          onClick={handleCreateSurvey}
        >
          Create new survey
        </Button>
      </div>
    </>
  )
}
